import React from 'react';

export const Milestone = ({
  className,
  color,
  width,
  height,
}: {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width || '28'}
    height={height || '29'}
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2168 5.5145C5.2168 4.7413 5.84361 4.1145 6.6168 4.1145H20.7573C21.2302 4.11469 21.6891 4.2558 22.0789 4.51465C22.468 4.77305 22.7701 5.13605 22.9579 5.55465C23.1455 5.97285 23.2138 6.43441 23.1579 6.88703C23.1019 7.33978 22.923 7.77268 22.6349 8.13373C22.6194 8.15313 22.6034 8.17212 22.5869 8.19068L19.7085 11.4289L22.5869 14.6672C22.6034 14.6857 22.6194 14.7047 22.6349 14.7241C22.923 15.0852 23.1019 15.5181 23.1579 15.9708C23.2138 16.4235 23.1455 16.885 22.9579 17.3032C22.7701 17.7218 22.468 18.0848 22.0789 18.3432C21.6891 18.6021 21.2308 18.7432 20.7579 18.7434H8.0168V24.7857C8.0168 25.5589 7.39 26.1857 6.6168 26.1857C5.84361 26.1857 5.2168 25.5589 5.2168 24.7857V5.5145ZM8.0168 15.9434H19.975L16.789 12.359C16.3175 11.8286 16.3175 11.0293 16.789 10.4988L19.975 6.9145H8.0168V15.9434Z"
      fill={color || '#5D54C0'}
    />
  </svg>
);
